
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import CelebrationIcon from '@mui/icons-material/Celebration';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import TtkList from './TtkList';
const BirthadayShoppingTTK = ({ data }) => {
    return (

        <>

            <div className="row">
                <div className="col-md-12">
                    <div className='row mb-1'>
                        <div className='col-md-6'>
                            <p> <WorkspacePremiumIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Working Since :</b>&nbsp;<TtkList data={data?.workingSince}/></p>
                        </div>
                        <div className='col-md-6'>
                            <p> <CelebrationIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Birthaday Decoration Items:</b>&nbsp;<TtkList data={data?.birthadayDecoration}/></p>
                        </div>

                    </div>
                    <div className='row'>
                        <div className='col-md-6'>
                            <p> <LocationCityIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Serving Cities :</b>&nbsp;<TtkList data={data?.areaOfWorking}/></p>
                        </div>
                        <div className='col-md-6'>
                            <p ><MonetizationOnIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Price:</b>&nbsp;<span>{data?.price}</span></p>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default BirthadayShoppingTTK